<template>
  <dialog-box v-if="showDialog" dialogWidth="600px" @close="closeDialog">
    {{ stopLottie() }}
    <div class="inr-enabled-dialog-content">
      <lottie-player
        :src="fetchLottieJSON"
        background="transparent"
        speed="1"
        style="width: 100%; height: 110px"
        :loop="lottieLoop"
        class="mb-2"
        autoplay
      ></lottie-player>
      <div class="header">
        {{ $t('dashboard.congratulationText.title') }}
      </div>
      <div class="sub-header">
        {{
          userLevel
            ? $t('dashboard.congratulationText.subtitle.prepend')
            : $t('dashboard.alternateCongratulationText.subtitle.prepend')
        }}
      </div>
      <div class="para">
        {{ $t('dashboard.congratulationText.subtitle.append') }}
      </div>
      <div class="d-flex justify-content-center">
        <action-button
          v-if="$route.name === 'invoicesAdd'"
          variant="solid"
          :click="closeDialog"
        >
          {{ $t('dashboard.congratulationText.continueSubmitting') }}
        </action-button>
        <div v-else class="drip-text-button" @click="closeDialog">
          {{ $t('dashboard.congratulationText.gotItText') }}
          <b-icon-check class="wealthy-green-color ml-2" scale="1.4" />
        </div>
      </div>
    </div>
  </dialog-box>
</template>

<script>
import DialogBox from '@/components/common/DialogBox'
import Confetti from '@/assets/images/lottie/confetti.json'
import ActionButton from '../common/ActionButton.vue'

export default {
  components: { DialogBox, ActionButton },
  props: ['userLevel', 'showDialog'],
  data() {
    return {
      lottieLoop: true,
      lottieJSON: Confetti
    }
  },
  computed: {
    fetchLottieJSON() {
      return JSON.stringify(this.lottieJSON)
    }
  },
  methods: {
    stopLottie() {
      if (this.showDialog) {
        setTimeout(() => {
          this.lottieLoop = false
        }, 4000)
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.inr-enabled-dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    object-fit: cover;
    height: 110px;
    width: 460px;
    margin: auto;
  }
  .header {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $noble-blue-500;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .sub-header {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $black;
  }
  .para {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    justify-content: center;
    color: $black;
    margin-bottom: 24px;
  }
}
</style>
